import { render, staticRenderFns } from "./LetterCube.vue?vue&type=template&id=5901589a&scoped=true&"
import script from "./LetterCube.vue?vue&type=script&lang=js&"
export * from "./LetterCube.vue?vue&type=script&lang=js&"
import style0 from "./LetterCube.vue?vue&type=style&index=0&id=5901589a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5901589a",
  null
  
)

export default component.exports